import { action, computed } from 'mobx';

import  {Group } from './Group.js';
import { sortByNumber } from '../../../helpers/helpers';

class GroupSingle extends Group {
  initCards = (products = []) => {
    this.addCards({products, shouldSyncAPI: true, showRelatedProducts: true});
  };

  constructor(item, rootStore) {
    super({item, rootStore});
    this.initCards(item.products);
  }

  @computed
  get selectCards() {
    return sortByNumber([...this.products], 'creationDate', -1);
  }

  @action.bound
  removeCard(item, withoutConfirm = false) {
    return this.rootStore.alterationsStore.whenRemoveItem({
      searchArr: this.products,
      withoutConfirm,
      contentText: this.rootStore.labelsStore.giftlistConfirmationQuestion.replace('#ID#', item.commRef),
      item
    });
  }
}

export { GroupSingle };
